// extracted by mini-css-extract-plugin
export default {"supplierColor":"SupplierColor_supplierColor__CV41j"};